import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowSpaceBetween: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    }
});
export default stylesheet;
